const groupName = 'Badging';
export const badgingSystemPermissions = {
    'manage-badge-templates-classifier': {
        group: groupName,
        label: 'Edit Badge Templates Classifier',
    },
    'manage-revoked-badge-reasons-classifier': {
        group: groupName,
        label: 'Edit Revoked Badge Reasons Classifier',
    },
    'manage-badges': {
        group: groupName,
        label: 'Manage Badges',
    },
    'manage-account-badges': {
        group: groupName,
        label: 'Manage Account Badges',
    },
    'revoke-account-badges': {
        group: groupName,
        label: 'Revoke Account Badges',
    },
};
